// extracted by mini-css-extract-plugin
export default {"reason":"ReturnsDisputesTable_reason__ZZwLx"};